'use client';

import { IOrganization, IRepository, IUser } from '@/types';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { IResponseError } from '@/lib/apiBase';
import { createRepositoryFork } from '@/lib/repositoryForkApi';
import { FeatureHeading } from '@/ui/components';

import { Row, Stack } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';
import RepositoryForkForm, { FormValues } from './RepositoryForkForm';

const CreateRepositoryFork: React.FC<{ user?: IUser; repository: IRepository; organizations?: IOrganization[] }> = ({
  user,
  repository,
  organizations = [],
}) => {
  const router = useRouter();
  const [error, setError] = useState<IResponseError>();

  const onComplete = (repository: IRepository) => {
    router.push(`/${repository.namespace}/${repository.name}`);
  };

  const onSubmit = async (params: FormValues) => {
    const { name, organizationId } = params;

    const response = await createRepositoryFork({ repository, newRepositoryName: name, organizationId });
    if (response?.status === 'error' && response.error) {
      setError(response.error);
    } else {
      response?.repository && onComplete(response?.repository);
    }
  };

  return (
    <Stack gap={20}>
      <div>
        <Row gap={10} alignItems="center">
          <b>Source:</b>
          <Row gap={5} alignItems="center">
            <Icon.Book /> {repository?.namespace}/{repository?.name}
          </Row>
        </Row>
      </div>
      {user ? (
        <RepositoryForkForm repository={repository} user={user} organizations={organizations} onSubmit={onSubmit} />
      ) : (
        <div>You must be logged in to fork a repository.</div>
      )}
    </Stack>
  );
};

export default CreateRepositoryFork;
